export default __webpack_public_path__ + "static/media/cover design.f3f31544.svg";